export default __webpack_public_path__ + "static/media/studlydozen.5272bdad.jpg";